import { Card as BaseBlockCard, InlineCard as BaseInlineCard } from '@syllepsis/adapter';
import { AccessLayer } from '@syllepsis/editor';
import { ReactRenderer } from './render-bridge';
var Card = AccessLayer(BaseBlockCard, ReactRenderer);
var InlineCard = AccessLayer(BaseInlineCard, ReactRenderer);
export { Card, InlineCard };
//# sourceMappingURL=card.js.map